import { LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * 郵便番号→住所自動入力コンポーネント
 *
 * @element kd-address-zip-autofill
 * @description 郵便番号入力時に zip2addr jQuery プラグインを呼び出して住所を自動入力する。
 *              jQuery 依存を局所化するラッパー。完全な jQuery 除去は別タスク。
 *
 * @attr {string} zip-selector - 郵便番号入力のセレクタ（デフォルト: #AddressZipNew）
 * @attr {string} pref-selector - 都道府県セレクタ（デフォルト: #AddressProvinceNew）
 * @attr {string} addr-selector - 市区町村入力のセレクタ（デフォルト: #AddressCityNew）
 */
@customElement('kd-address-zip-autofill')
export class KdAddressZipAutofill extends LitElement {
  createRenderRoot() {
    return this;
  }

  @property({ type: String, attribute: 'zip-selector' })
  zipSelector = '#AddressZipNew';

  @property({ type: String, attribute: 'pref-selector' })
  prefSelector = '#AddressProvinceNew';

  @property({ type: String, attribute: 'addr-selector' })
  addrSelector = '#AddressCityNew';

  private boundHandleKeyup: (() => void) | null = null;

  connectedCallback(): void {
    super.connectedCallback();

    this.boundHandleKeyup = this.initZip2Addr.bind(this);
    const zipInput = document.querySelector(this.zipSelector);
    if (zipInput) {
      zipInput.addEventListener('keyup', this.boundHandleKeyup);
    }

    // 初回の zip2addr 初期化
    this.initZip2Addr();
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();

    if (this.boundHandleKeyup) {
      const zipInput = document.querySelector(this.zipSelector);
      if (zipInput) {
        zipInput.removeEventListener('keyup', this.boundHandleKeyup);
      }
      this.boundHandleKeyup = null;
    }
  }

  private initZip2Addr(): void {
    const $ = (window as unknown as Record<string, unknown>).jQuery as
      | ((selector: string) => { zip2addr?: (options: { pref: string; addr: string }) => void })
      | undefined;

    if (!$) return;

    try {
      const zipEl = $(this.zipSelector);
      if (zipEl?.zip2addr) {
        zipEl.zip2addr({
          pref: this.prefSelector,
          addr: this.addrSelector,
        });
      }
    } catch {
      // zip2addr が未ロードの場合はスキップ
    }
  }

  render() {
    return nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'kd-address-zip-autofill': KdAddressZipAutofill;
  }
}
